// Component pieces
import renderer from './renderer'

const ComplianceHelpComponent = (renderer)

export default ComplianceHelpComponent
